import * as THREE from "three";

function configureTexture(texture) {
  texture.wrapS = THREE.RepeatWrapping;

  texture.wrapT = THREE.RepeatWrapping;

  texture.colorSpace = THREE.SRGBColorSpace;

  texture.needsUpdate = true;

  return texture;
}

function createCheckerTexture() {
  const size = 512;

  const canvas = document.createElement("canvas");

  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext("2d");

  const cells = 8;
  const cellSize = size / cells;

  for (let y = 0; y < cells; y++) {
    for (let x = 0; x < cells; x++) {
      const light = (x + y) % 2 === 0;

      context.fillStyle = light ? "#ffffff" : "#555555";

      context.fillRect(x * cellSize, y * cellSize, cellSize, cellSize);
    }
  }

  return configureTexture(new THREE.CanvasTexture(canvas));
}

function createUVGridTexture() {
  const size = 512;

  const canvas = document.createElement("canvas");

  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext("2d");

  context.fillStyle = "#ffffff";

  context.fillRect(0, 0, size, size);

  const cells = 8;
  const cellSize = size / cells;

  context.lineWidth = 2;
  context.strokeStyle = "#222222";

  for (let i = 0; i <= cells; i++) {
    const position = i * cellSize;

    context.beginPath();

    context.moveTo(position, 0);

    context.lineTo(position, size);

    context.stroke();

    context.beginPath();

    context.moveTo(0, position);

    context.lineTo(size, position);

    context.stroke();
  }

  context.font = "20px monospace";

  context.textAlign = "center";

  context.textBaseline = "middle";

  context.fillStyle = "#222222";

  for (let y = 0; y < cells; y++) {
    for (let x = 0; x < cells; x++) {
      context.fillText(
        `${x},${y}`,

        x * cellSize + cellSize / 2,

        y * cellSize + cellSize / 2,
      );
    }
  }

  return configureTexture(new THREE.CanvasTexture(canvas));
}

export const TEXTURE_LIBRARY = {
  none: {
    id: "none",
    name: "None",
    create: () => null,
  },

  checker: {
    id: "checker",
    name: "Checker",
    create: createCheckerTexture,
  },

  "uv-grid": {
    id: "uv-grid",
    name: "UV Grid",
    create: createUVGridTexture,
  },
};

export const TEXTURE_LIST = Object.values(TEXTURE_LIBRARY);

export function getTextureDefinition(id) {
  return TEXTURE_LIBRARY[id] ?? TEXTURE_LIBRARY.none;
}
